/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Bulk_Hide_EachInputs */



/**
* | output |
* | --- |
* | "Hide details" |
*
* @param {Chat_Tool_Bulk_Hide_EachInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_hide_each = /** @type {((inputs?: Chat_Tool_Bulk_Hide_EachInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Hide_EachInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Details ausblenden")
	return /** @type {LocalizedString} */ ("Hide details")
});